


























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product, Company } from '@/store/modules/lib';

@Component
export default class ProductMainInfo extends Vue {

  @Prop({ type: Object, default: null }) protected product!: Product;
  @Prop({ type: Array, default: () => [] }) protected standCompanies!: Company[];

  protected get standTitle() {

    if (this.product != null && this.product._company != '') {
      let companies = this.standCompanies.filter((company: Company) => company._id == this.product._company);
      return companies.length > 0 ? companies[0].standTitle : '';
    }

    return '';

  }

}

